var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_134_10885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16669 12.5001C3.39012 12.5001 3.00183 12.5001 2.69555 12.3732C2.28717 12.2041 1.96271 11.8796 1.79355 11.4712C1.66669 11.1649 1.66669 10.7767 1.66669 10.0001V4.33341C1.66669 3.39999 1.66669 2.93328 1.84834 2.57676C2.00813 2.26316 2.2631 2.00819 2.5767 1.8484C2.93322 1.66675 3.39993 1.66675 4.33335 1.66675H10C10.7766 1.66675 11.1649 1.66675 11.4712 1.79362C11.8795 1.96277 12.204 2.28723 12.3732 2.69561C12.5 3.00189 12.5 3.39018 12.5 4.16675M10.1667 18.3334H15.6667C16.6001 18.3334 17.0668 18.3334 17.4233 18.1518C17.7369 17.992 17.9919 17.737 18.1517 17.4234C18.3334 17.0669 18.3334 16.6002 18.3334 15.6667V10.1667C18.3334 9.23333 18.3334 8.76662 18.1517 8.4101C17.9919 8.09649 17.7369 7.84153 17.4233 7.68174C17.0668 7.50008 16.6001 7.50008 15.6667 7.50008H10.1667C9.23327 7.50008 8.76656 7.50008 8.41004 7.68174C8.09643 7.84153 7.84147 8.09649 7.68168 8.4101C7.50002 8.76662 7.50002 9.23333 7.50002 10.1667V15.6667C7.50002 16.6002 7.50002 17.0669 7.68168 17.4234C7.84147 17.737 8.09643 17.992 8.41004 18.1518C8.76656 18.3334 9.23327 18.3334 10.1667 18.3334Z",
    stroke: "#3A3A3C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_134_10885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.cf47bb69d5853d34f751b29d04833a26.svg";
export { ForwardRef as ReactComponent };